// extracted by mini-css-extract-plugin
export default {"tab":"styles__tab--lpMP3","tab-menu":"styles__tab-menu--icyDq"};